import { useState, useMemo } from 'react';
import { CatalogProductNew } from "../../Product/CatalogProductNew/CatalogProductNew";
import styles from './LubematchProductCard.module.css'

export const LubematchVariantCard = ({ variants = [], toast }) => {
    const [selectedIdx, setSelectedIdx] = useState(0);

    const sortedVariants = useMemo(() => {
        const parseVol = (p) => {
            if(p && p.Volume != null) return Number(p.Volume) || 0;
            const m = (p?.ProductName || '').match(/,\s*(\d+(?:[\.,]\d+)?)\s*л$/i);
            if(m){
                return Number(String(m[1]).replace(',', '.')) || 0;
            }
            return 0;
        };
        return [...variants].sort((a,b) => parseVol(a) - parseVol(b));
    }, [variants]);

    const current = sortedVariants[selectedIdx] || sortedVariants[0];
    if(!current){
        return null;
    }

    const getVolumeLabel = (p) => {
        const volNum = Number(p?.Volume);
        if (!isNaN(volNum) && volNum > 0) {
            return `${volNum}л`;
        }
        const name = p?.ProductName || '';
        // Match volume or weight at the end, e.g. ", 1л" or ", 0,4кг"
        const m = name.match(/,\s*(\d+(?:[\.,]\d+)?)\s*(л|кг)$/i);
        if (m) {
            const rawNum = m[1];
            const unit = m[2].toLowerCase();
            const num = Number(String(rawNum).replace(',', '.'));
            if (!isNaN(num) && num > 0) {
                // Preserve comma-style if present in source name
                const displayNum = String(rawNum).replace('.', ',');
                return `${displayNum}${unit}`;
            }
        }
        return '—';
    };

    return (
        <div className={styles.variantCard} style={{display:'flex', flexDirection:'column', gap: '8px', width:'100%'}}>
            <div style={{display:'flex', gap:'6px', flexWrap:'wrap', padding:'2px 2px 0 2px', minHeight:'36px'}}>
                {sortedVariants.map((p, idx) => (
                    <button
                        key={p.Id}
                        onClick={() => {
                            if(sortedVariants.length > 1){ setSelectedIdx(idx); }
                        }}
                        style={{
                            border: idx === selectedIdx ? '2px solid #fbce07' : '1px solid #e5e7eb',
                            background: idx === selectedIdx ? '#fff9d6' : '#ffffff',
                            borderRadius: '8px',
                            padding: '4px 8px',
                            cursor: sortedVariants.length > 1 ? 'pointer' : 'default',
                            fontFamily: 'Commissioner',
                            opacity: sortedVariants.length > 1 ? 1 : 0.9,
                        }}
                    >
                        {getVolumeLabel(p)}
                    </button>
                ))}
            </div>
            <CatalogProductNew
                id={current.Id}
                name={current.ProductName}
                number={current.ProductNumber}
                articleList={current.ArticleList}
                recommendPrice={current.ReccomendPrice}
                priceList={current.ProductPriceList}
                count={current.Count}
                key={current.Id}
                balance={current.TotalBalance}
                deliveryDate={current.DeliveryDate}
                isDiscount={current.IsDiscount}
                smallImageUrls={current.SmallImageUrl}
                countInCart={current.countInCart}
                toast={toast}
                lubematchCard={true}
            />
        </div>
    )
}
